/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_CopyInputs */

const en_us2_invite_copy = /** @type {(inputs: Invite_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy code`)
};

const pt_br2_invite_copy = /** @type {(inputs: Invite_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar código`)
};

const pt_pt2_invite_copy = /** @type {(inputs: Invite_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar código`)
};

/** @type {(inputs: Invite_CopyInputs) => LocalizedString} */
const es_419_invite_copy = en_us2_invite_copy;

/** @type {(inputs: Invite_CopyInputs) => LocalizedString} */
const fr_fr2_invite_copy = en_us2_invite_copy;

/** @type {(inputs: Invite_CopyInputs) => LocalizedString} */
const de_de2_invite_copy = en_us2_invite_copy;

/** @type {(inputs: Invite_CopyInputs) => LocalizedString} */
const it_it2_invite_copy = en_us2_invite_copy;

/**
* | output |
* | --- |
* | "Copy code" |
*
* @param {Invite_CopyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_copy = /** @type {((inputs?: Invite_CopyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_CopyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_copy(inputs)
	if (locale === "es-419") return es_419_invite_copy(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_copy(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_copy(inputs)
	if (locale === "de-DE") return de_de2_invite_copy(inputs)
	if (locale === "it-IT") return it_it2_invite_copy(inputs)
	return en_us2_invite_copy(inputs)
});
export { invite_copy as "invite.copy" }